module.exports = __webpack_public_path__ + "img/logo.19b9e903.svg";